/**
 * in this file there are the 2 functions that manage:
 * the PC forms
 * the accessibility form
 */
 import vector from './vector_consult'
 import functions from '../common/functions'

 /**
  * global var for more form
  */

 let formClicked = false
 let commentControls = $('#commentquestions').detach()
 let issueControls = $('#issuequestions').detach()
 let surveyControls = $('#surveyquestions').detach()
 var formtimer
 var elapsed
 let privacyOn = false
 /**
  * public consultation form
  */

 const initPcForm = () => {
   /**
    * send comment in the scheme list
    */

   $('.consultcomment').on('click', function (e) {
    consultInit($(this).attr('data-schemeid'),$(this).attr('data-schemename'), 'N/A',0,'N/A','N/A',0, '1')
   })
   $('.consultsurvey').on('click', function (e) {
    consultInit($(this).attr('data-schemeid'),$(this).attr('data-schemename'),  'N/A',0,'N/A','N/A',0, '3')
   })

 }
/**
 * setConsultType
 * 1 = Comment (commentquestions)
 * 2 = issue (issuequestions)
 * 3 = survey (surveyquestions)
 */
 const setConsultType = (consulttype) => {
   //first detach any current forms
   $('.consultquestions').each(function () {
      if ($(this).attr("data-consult_type") === "1") {
        commentControls = $('#commentquestions').detach()
      } else if ($(this).attr("data-consult_type") === "2") {
        issueControls = $('#issuequestions').detach()
      } else if ($(this).attr("data-consult_type") === "3") {
        surveyControls = $('#surveyquestions').detach()
      }
   })

    //set survey type depending in init:
   if (consulttype === "1") {
    commentControls.appendTo('#questions')
   } else if (consulttype === "2") {
    issueControls.appendTo('#questions')
   } else if (consulttype === "3") {
    surveyControls.appendTo('#questions')
   }
 }

 /**
  * Init Consultation Form
  */
 const consultInit = (schemeId, schemeSelected, coords, markId,street,restriction,pm_id,consulttype) => {
   /**
    * reset the form
    * reset all the errors
    * close menus if mobile
    * close popup
    */
   privacyOn = false

    $('#sessionexpires').removeClass('expirewarning')
    if (functions.mobileTabletView()) {
      if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
         $('#dropdownToolsMobile').trigger('click')
      }
      if ($('#mainNav').hasClass('show')) {
        $('#mainNav').removeClass('show')
      }
    }
    // close modal  popup
    $('#mobpopup').modal('hide');
    // Set the type 1: Comment, 2: Issue, 3: Survey
    setConsultType(consulttype)
     // Reset the validation on the comment form
    document.getElementById('consultationForm').reset()
    $('#consultationForm select').removeClass('error')
    $('#consultationForm select').css('color', 'black')
    $('.consult_error').css('display', 'none')
    $('.reqfield').hide()
    $('#consultationdialog').modal({
      backdrop: 'static',
      keyboard: false
    })

    // populate the dialog title and scheme information

    if (consulttype === "1") {
      $('#consult_dialog_title').text($('#consult_dialog_title').attr('data-title1'))
      $('.comm_preamble').css('display','none')
      if (restriction !== 'N/A') {
        $('#consult_dialog_title').text($('#consult_dialog_title').attr('data-title11'))
        $('#comment_restriction').css('display','block')

        $('#consult_scheme_1').text($('#consult_scheme_1').attr('data-scheme') + schemeSelected + ', ' + $('#consult_scheme_1').attr('data-street') + street + ', ' + $('#consult_scheme_1').attr('data-restriction')+ restriction)
      } else {
        $('#comment_general').css('display','block')
        $('#consult_scheme_1').text($('#consult_scheme_1').attr('data-scheme') + schemeSelected)
      }
     } else if (consulttype === "2") {
      $('#consult_dialog_title').text($('#consult_dialog_title').attr('data-title2'))
      $('#consult_scheme_2').text($('#consult_scheme_2').attr('data-scheme') + schemeSelected)
     } else if (consulttype === "3") {
      $('#consult_dialog_title').text($('#consult_dialog_title').attr('data-title3'))
      $('#consult_scheme_3').text($('#consult_scheme_3').attr('data-scheme') + schemeSelected)
     }
    /**
    * populate the scheme id, street name
    * scheme id, restriction, coords form fields
    */

   $('#consult_markid').val(markId)
   if (coords !== 'N/A') {
    vector.removeMarker()
  } else {
    $('#consult_coords').val(coords)
  }
   $('#consult_type').val(consulttype)
   $('#consult_schemeid').val(schemeId)
   $('#consult_restriction').val(restriction)
   $('#consult_street_name').val(street)
   $('#consult_pm_id').val(pm_id)

   // reset page controls
   $('#pageSlider').val(0)
   $('#pageSlider').attr('min', 0)
   $('#pageSlider').attr('max', $('.consult_page').last().attr('data-pageno'))
   $('.consult_page_show').each(function () {
     $(this).removeClass('consult_page_show').addClass('consult_page_hide')
   })
   $('.page_0').removeClass('consult_page_hide').addClass('consult_page_show')

   $('#consultNext').css('display', 'block')
   $('#consultBack').css('display', 'none')
   $('#consultFinish').css('display', 'none')
   $('#consultFinish, #askFinish').prop('disabled',false)
   // page back function
   $('#consultBack').off().click(function (e) {
     e.preventDefault()
     //let curPage = parseInt($('#pageSlider').val())
     let curPage = parseInt(document.getElementById("pageSlider").value)
     if (parseInt(curPage - 1) < 0) {
       return
     }
     $('.page_' + curPage).removeClass('consult_page_show').addClass('consult_page_hide')
     curPage -= 1
     if (curPage > 0) {
      $('#consultBack').css('display', 'block')
     } else {
      $('#consultBack').css('display', 'none')
     }
     $('#pageSlider').val(curPage)
     document.getElementById("pageSlider").value = curPage
     $('.page_' + curPage).removeClass('consult_page_hide').addClass('consult_page_show')
     if ($('.page_' + curPage + ' #askFinish').length > 0) {
       $('#consultNext').css('display', 'none')
     }
     else {
       $('#consultNext').css('display', 'block')
     }
     $('#consultFinish').css('display', 'none')
   })
   // next page function
   $('#consultNext, #askNext').off().click(function (e) {
     e.preventDefault()
     let curPage = parseInt($('#pageSlider').val())
     if (validatePage(curPage)) {
       $('.page_' + curPage + ' .consult_error').css('display', 'none')
       if (parseInt(curPage + 1) > $('#pageSlider').attr('data-max')) {
         return
       }
       $('.page_' + curPage).removeClass('consult_page_show').addClass('consult_page_hide')
       curPage += 1
       if (curPage > 0) {
        $('#consultBack').css('display', 'block')
       } else {
        $('#consultBack').css('display', 'none')
       }
       $('#pageSlider').val(curPage)
       $('.page_' + curPage).removeClass('consult_page_hide').addClass('consult_page_show')
       if ($('.page_' + curPage + ' #askFinish').length > 0) {
         $('#consultNext').css('display', 'none')
       }
       else {
         $('#consultNext').css('display', 'block')
       }
       if (parseInt(curPage) === parseInt($('#pageSlider').attr('max'))) {
         $('#consultNext').css('display', 'none')
         $('#consultFinish').css('display', 'block')
         checkConsultPrivacyFields()
       }
       $('.page_' + curPage + ' .page_prompt').first().removeClass('hide')
     }
   })

   $('.consult_radio_val, .consult_multi_val, .consult_radio_val_h').off().click(function () {
     $('#consulterror_' + $(this).attr('data-question')).css('display', 'none')
   })

   /**
    *  hide multiboxhide
    */

   $('.multiboxhide').hide()
   /**
    * click event on .multibox .othercheck to diplay the hidden input
    */

   $('.othercheck').off().click(function () {
     if (this.checked) {
       $('#' + $(this).attr('data-textbox')).show()
     }
     else {
       $('#' + $(this).attr('data-textbox')).hide()
       $('#' + $(this).attr('data-textbox')).val('')
     }
   })

   $('.consult_radio_val, .consult_radio_val_h').off().click(function () {
     if ($(this).val() === '99') {
       $('#' + $(this).attr('data-textbox')).show()
     }
     else {
       $('#' + $(this).attr('data-textbox')).hide()
       $('#' + $(this).attr('data-textbox')).val('')
     }
   })
   /**
    * click event on .multibox to create the final array of data for each checked checkbox
    */
   $('.consultmultibox').off().click(function () {
     let selected = []
     $('#' + $(this).attr('id') + ' input:checked').each(function () {
       selected.push($(this).attr('value'))
     })
     $('#' + $(this).attr('data-inputbox')).val(selected.join(','))
  })

   function validatePage (curPage) {
     // select items on current page
     var valid = true
     if (curPage === 0) {
       return true
     }

     $('.consult_error').css('display','none')

     $('.page_' + curPage + ' .privacycontrol').each(function () {
        let ctlId = $(this).attr('id')
        let qErrorId = '#consulterror_' + $(this).attr('data-question')
        // validation
        $(qErrorId).css('display', 'none')
        if (!document.getElementById(ctlId).checkValidity()) {
          valid = false
        }
        return valid
     })

     $('.page_' + curPage + ' .consult_text_val').each(function () {
       // check text not blank
       if ($(this).val().length < parseInt($(this).attr('minlength'))) {
         $('#consulterror_' + $(this).attr('data-question')).css('display', 'block')
         valid = false
       }
       return valid
     })

     $('.page_' + curPage + ' .consultmultibox').each(function () {
       // check between min and max
       let thisCtl = $(this).attr('data-inputbox')
       let valuesChecked = 0

       if ($('#' + thisCtl).val().indexOf(',') !== -1) {
         valuesChecked = $('#' + thisCtl).val().split(',').length
       }
       else {
         if ($('#' + thisCtl).val() !== '') {
           valuesChecked = 1
         }
       }
       if (valuesChecked < parseInt($('#' + thisCtl).attr('data-min')) || valuesChecked > parseInt($('#' + thisCtl).attr('data-max'))) {
         $('#consulterror_' + $('#' + thisCtl).attr('data-question')).css('display', 'block')
         valid = false
       }

       return valid
     })

     // validate other box
     $('.page_' + curPage + ' .multiboxhide').each(function () {
       if ($(this).css('display') !== 'none' && $(this).val() === '') {
         $('#' + $(this).attr('data-error')).css('display', 'block')
         valid = false
       } else {
        $('#' + $(this).attr('data-error')).css('display', 'none')
       }
       return valid
     })

     $('.page_' + curPage + ' .consult_radio_val').each(function () {
       let thisCtl = $(this).attr('name')
       if ($('input[name=' + thisCtl + ']:checked').length === 0) {
         $('#consulterror_' + $(this).attr('data-question')).css('display', 'block')
         valid = false
       }

       return valid
     })

     $('.page_' + curPage + ' .consult_radio_val_h').each(function () {
      let thisCtl = $(this).attr('name')
      if ($('input[name=' + thisCtl + ']:checked').length === 0) {
        $('#consulterror_' + $(this).attr('data-question')).css('display', 'block')
        valid = false
      }

      return valid
    })


     $('.page_' + curPage + ' .consult_radio_val.othercheck').each(function () {
       let thisCtl = $(this).attr('data-textbox')
       if ($('#' + thisCtl).css('display') === 'block' && $('#' + thisCtl).val() === '') {
         $('#consulterror_' + $(this).attr('data-question')).css('display', 'block')
         $('#' + thisCtl).closest('.custom-checkbox').find('.reqfield').show()
         valid = false
       }
       return valid
     })

     // check contact details match preference
    if ($('.page_' + curPage + ' .contact').filter(":checked").length > 0) {
      let thisId = $('.page_' + curPage + ' .contact').filter(":checked").first().attr('id')
      let thisContact = $('[for=' + thisId + ']').text().toLowerCase()
      switch(thisContact) {
        case 'email':
          if ($('.email').val() === '') {
            $('#contacterror_' + $('#' + thisId).attr('data-question')).css('display', 'block')
            $('#contactmsg_' + $('#' + thisId).attr('data-question')).text(thisContact)
            valid = false
          }
          break;
        case 'post':
          if ($('.post').val() === '') {
            $('#contacterror_' + $('#' + thisId).attr('data-question')).css('display', 'block')
            $('#contactmsg_' + $('#' + thisId).attr('data-question')).text(thisContact)
            valid = false
          }

          break;
        case 'phone':
          if ($('.phone').val() === '') {
            $('#contacterror_' + $('#' + thisId).attr('data-question')).css('display', 'block')
            $('#contactmsg_' + $('#' + thisId).attr('data-question')).text(thisContact)
            valid = false
          }
          break;
        default:
          $('#contacterror_' + $('#' + thisId).attr('data-question')).css('display', 'none')
      }
    }

     return valid
   }

   $('#consultCancel').off().click(function (e) {
    vector.removeMarker()
    stopTimer()
   })
   // SURVEY SUBMIT
   $('#consultFinish, #askFinish').off().click(function (e) {
    e.preventDefault()
     $(this).prop('disabled',true)
     $('#consultCancel').prop('disabled',true)
     if ($(this).attr('id') === 'askFinish') {
       let thisCtl = $(this).attr('data-inputbox')
       $('#' + thisCtl).val('NO')
     }

     let curPage = parseInt($('#pageSlider').val())
     if (validatePage(curPage)) {
         stopTimer()
         $('.loading').show()
         $('#consultationForm').submit()
     }
     else {
       $(this).prop('disabled',false)
       $('#consultCancel').prop('disabled',false)
       e.preventDefault()
     }
   })


  /**
   * set terms and conditions checkboxes
   *
   */

   $('.consent').css('display', 'none')

   //check confidential fields for validity and show error
   $('.privacycontrol').on('change',function (evt) {
      let ctlId = $(this).attr('id')
      let qErrorId = '#consulterror_' + $(this).attr('data-question')
      // validation
      $(qErrorId).css('display', 'none')
      if (!document.getElementById(ctlId).checkValidity()) {
        $(qErrorId).css('display', 'block')
        $('.consent').css('display', 'block')
      }
      if ($(this).val() === '') {
        $('.consent').css('display', 'none')
      }
      checkConsultPrivacyFields()
   })


   $('#dacceptprivacy').on('click', function() {
    if ($('#dacceptprivacy').prop('checked')) {
      $('#consultFinish').prop('disabled', false)
      $('#privacyerror').css('display', 'none')
    }
    else {
      $('#consultFinish').prop('disabled', true)
      $('#privacyerror').css('display', 'block')
    }
   })
   function checkConsultPrivacyFields () {
     // use privacycontrol

     $('.privacycontrol').each(function () {
        if ($(this).val() !== '') {
          privacyOn = true
        }
     })
     let curPage = parseInt($('#pageSlider').val())
     if (parseInt(curPage) === parseInt($('#pageSlider').attr('max'))) {
        if (privacyOn === false) {
        $('#consultFinish').prop('disabled', false)
        $('.consent').css('display', 'none')
        $('#privacyerror').css('display', 'none')
        return
        } else {
            $('#consultFinish').prop('disabled', false)
            $('.consent').css('display', 'block')
            if ($('#dacceptprivacy').prop('checked')) {
            $('#consultFinish').prop('disabled', false)
            }
            else {
            $('#consultFinish').prop('disabled', true)
            $('#privacyerror').css('display', 'block')
            }
        }
     }

     if ($('#consult_type').val() === '3') {
      $('.dfconsent').css('display','none')
      $('.fconsent').css('display','none')
     }
   }
   /**
    * show the form div
    * hide the sent status div
    */

   $('#consultDiv').css('display', 'block')
   $('#consultMsg').css('display', 'none')


   /**
    * hide the sentOk/sentErr divs
    */

   $('#sentOk').css('display', 'none')
   $('#sentErr').css('display', 'none')

   /**
    * show the modal
    */

   $('#consultationdialog').modal('show')


   startTimer()
   /**
    * end consultSurveyInit
    */
 }

 function stopTimer() {
  clearInterval(formtimer)
 }

 function startTimer() {
   // Set the date we're counting down to
   var sessionLife = parseInt($('#sessionlife').val())*1000;
   elapsed = 0
   // Update the count down every 1 second
   formtimer = setInterval(function() {

   // Find the distance between now and the count down date
   elapsed += 1000
   var distance = sessionLife - elapsed;

   // Time calculations for days, hours, minutes and seconds
   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
   var seconds = Math.floor((distance % (1000 * 60)) / 1000)

   // Display the result in the element with id="demo"
   let  msgstart = $('#sessionexpires').attr('data-session')
   let  msgunit1 = $('#sessionexpires').attr('data-minutes')
   let  msgunit2 = $('#sessionexpires').attr('data-seconds')
   document.getElementById("sessionexpires").innerHTML = msgstart + minutes + msgunit1 + seconds + msgunit2

   // If the count down is finished, write some text
   if (distance < 0) {
       stopTimer()
       document.getElementById("sessionexpires").innerHTML = $('#sessionexpires').attr('data-expired')
       $('#consultNext').css('display','none')
       $('#consultBack').css('display','none')
       $('#consultFinish').css('display','none')
       $('#sessionexpires').addClass('expirewarning')
   }
   }, 1000)
 }
/**
 * EXPORT
 */

export default {
  consultInit,
  initPcForm
}
